import { render, staticRenderFns } from "./WallOptions.vue?vue&type=template&id=dcc911ea&lang=pug&"
import script from "./WallOptions.vue?vue&type=script&lang=js&"
export * from "./WallOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports